import GetInTouch from "../../Components/GetInTouch/GetInTouch";
import classes from "./CeoColumn.module.scss";

function CeoColumn() {
  return (
    <div className={classes.container}>
      <div className={classes["main-section"]}>
        <div className={classes["ceo-info"]}>
          <div className={classes.title}>The CEO’s Column</div>

          <p className={classes.description}>
            In an era defined by rapid technological evolution, we stand at the
            intersection of two of the most transformative forces of our
            time—Artificial Intelligence and Clean Energy. At Sustainability
            Economics.ai, our mission is clear: to accelerate the global
            transition to an AI-driven, clean-energy-powered future.AI is no
            longer a standalone innovation; it is the foundation of modern
            industries. By integrating AI with energy solutions, we are
            optimizing efficiency, reducing emissions, and unlocking new
            economic opportunities. AI is reshaping industries, and we are at
            the forefront, ensuring this transformation is both scalable and
            sustainable.
            <br />
            As we lay the foundation for an AI-powered world, we invite
            innovators, businesses, and policymakers to collaborate in shaping a
            future where intelligence meets sustainability.
          </p>
        </div>

        <img
          className={classes["ceo-img"]}
          src="https://se-website-image.s3.ap-south-1.amazonaws.com/about-us/people/ceo.png"
          alt="CEO"
        />
      </div>

      <GetInTouch />
    </div>
  );
}

export default CeoColumn;
